import type { ForwardedRef, MutableRefObject, RefAttributes } from 'react';
import React from 'react';
import { Input } from '@itandi/itandi-bb-ui';
import { useDebounce } from '~/hooks/useDebounce';

type Props = {
  placeholder?: string;
  debounceDelay?: number;
  defaultValue?: string;
  handleChange: (searchWord: string) => void | Promise<void>; // useCallbackでWrapすること
};

export const SearchInput: React.FC<Props & RefAttributes<HTMLInputElement>> =
  React.forwardRef(
    (
      {
        placeholder,
        debounceDelay = 200,
        defaultValue = '',
        handleChange
      }: Props,
      ref: MutableRefObject<HTMLInputElement> | ForwardedRef<HTMLInputElement>
    ) => {
      const [searchWord, setSearchWord] = React.useState<string>(defaultValue);
      const debounce = useDebounce(debounceDelay);
      const onChangeWord = (e: React.ChangeEvent<HTMLInputElement>): void => {
        const inputValue = e.target.value;
        setSearchWord(inputValue);
        debounce(() => {
          handleChange(inputValue);
        });
      };
      return (
        <Input
          ref={ref}
          onChange={onChangeWord}
          placeholder={placeholder}
          type="search"
          value={searchWord}
        />
      );
    }
  );
